<template>
  <div class="menu-wrap">
    <!-- 桌面端导航 -->
    <el-row :gutter="20" class="desktop-nav">
      <el-col :span="5" class="logo">
        <img src="../../assets/logo.png" alt="">
      </el-col>
      <el-col :span="12" class="headermenu">
        <div v-for="val in menuInfo" :key="val.id" @click="goPage(val)" class="menu-li"
          :class="activeStatus == val.url ? 'menuActive' : ''">{{ val.name }}</div>
      </el-col>
      <el-col :span="7" class="hedersetting">
        <div class="btn buy" @click="handleProcurement">我要采购</div>
        <div class="btn sell" @click="handleSupply">我要供货</div>
      </el-col>
    </el-row>

    <!-- 移动端导航 -->
    <div class="mobile-nav">
      <div class="mobile-logo">
        <img src="../../assets/logo.png" alt="">
      </div>
      <div class="mobile-btns">
        <span class="mobile-btn-text" @click="handleProcurement">我要采购</span>
        <span class="mobile-btn-text sell-text" @click="handleSupply">我要供货</span>
      </div>
      <div class="hamburger-btn" @click="toggleMobileMenu" :class="{ 'is-active': mobileMenuVisible }">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>

    <!-- 移动端遮罩层 -->
    <div class="overlay" v-show="mobileMenuVisible" @click="toggleMobileMenu"></div>

    <!-- 移动端侧滑菜单 -->
    <div class="mobile-menu" :class="{ 'menu-open': mobileMenuVisible }">
      <div class="mobile-menu-header">
        <span class="menu-title">导航菜单</span>
        <span class="menu-close" @click="toggleMobileMenu">✕</span>
      </div>
      <div class="mobile-menu-list">
        <div v-for="val in menuInfo" :key="val.id"
          @click="goPageMobile(val)"
          class="mobile-menu-li"
          :class="activeStatus == val.url ? 'mobile-menu-active' : ''">
          {{ val.name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeStatus: '',
      mobileMenuVisible: false,
      menuInfo: [
        { id: 1, name: '首页', url: '/' },
        { id: 2, name: '产品服务', url: '/service' },
        { id: 5, name: '开放平台API', url: '' },
        { id: 6, name: '关于我们', url: '/about' },
      ],
      visible: false,
    }
  },
  created() {
    this.activeStatus = window.location.pathname
  },
  methods: {
    toggleMobileMenu() {
      this.mobileMenuVisible = !this.mobileMenuVisible
    },
    goPage(val) {
      if (val.id == 5) {
        window.open('https://s.apifox.cn/0d09ddbe-0532-45e7-a604-11b1e50f1b97', '_blank');
      } else {
        if (!val.url) return;
        this.activeStatus = val.url
        this.$router.push(val.url)
      }
    },
    goPageMobile(val) {
      this.mobileMenuVisible = false
      this.goPage(val)
    },
    handleProcurement() {
      window.open('https://mancmss.birdicloud.com/#/index', '_blank');
    },
    handleSupply() {
      this.$message.success('敬请期待～');
    }
  }
}
</script>

<style lang="less" scoped>
@primary-color: #2376e3;

.menu-wrap {
  position: fixed;
  top: 0;
  width: 100vw;
  box-sizing: border-box;
  z-index: 99;
  background: #ffffff;

  // 桌面端导航
  .desktop-nav {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }
  .logo {
    text-align: right;

    .name {
      font-size: 16px;
      color: @primary-color;
    }
  }

  .headermenu {
    height: 100%;
    display: flex;

    .menu-li {
      font-size: 18px;
      margin-right: 5%;
      cursor: pointer;
    }

    .menuActive {
      color: @primary-color;
      font-size: 20px;
      font-weight: bold;
    }
  }

  .hedersetting {
    display: flex;

    .btn {
      width: 100px;
      padding: 5px 0;
      border-radius: 30px;
      text-align: center;
      font-size: 14px;
      color: #ffffff;
      cursor: pointer;
      transition: transform 0.3s ease, box-shadow 0.3s ease, background-color 0.3s ease;

      &:hover {
        transform: translateY(-2px) scale(1.05);
        box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
      }

      &:active {
        transform: scale(0.97);
      }
    }

    .buy {
      background-color: #7bb2f9;

      &:hover {
        background-color: #5a9ff5;
        box-shadow: 0 6px 20px rgba(123, 178, 249, 0.4);
      }
    }

    .sell {
      margin-left: 20px;
      background-color: #fcca27;

      &:hover {
        background-color: #f5be00;
        box-shadow: 0 6px 20px rgba(252, 202, 39, 0.4);
      }
    }
  }

  // 移动端导航（默认隐藏）
  .mobile-nav {
    display: none;
  }

  // 移动端遮罩
  .overlay {
    display: none;
  }

  // 移动端侧滑菜单
  .mobile-menu {
    display: none;
  }
}

// ========== 移动端适配 ==========
@media (max-width: 768px) {
  .menu-wrap {
    padding: 8px 16px;

    // 隐藏桌面端导航
    .desktop-nav {
      display: none !important;
    }

    // 显示移动端导航
    .mobile-nav {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 40px;

      .mobile-logo img {
        height: 32px;
      }

      .mobile-btns {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-left: auto;
        margin-right: 16px;

        .mobile-btn-text {
          font-size: 13px;
          color: #2376e3;
          white-space: nowrap;
          cursor: pointer;

          &.sell-text {
            color: #e6a800;
          }
        }
      }

      .hamburger-btn {
        width: 24px;
        height: 20px;
        position: relative;
        cursor: pointer;
        flex-shrink: 0;

        span {
          display: block;
          position: absolute;
          height: 2px;
          width: 100%;
          background: #333;
          border-radius: 2px;
          transition: all 0.3s ease;

          &:nth-child(1) { top: 0; }
          &:nth-child(2) { top: 9px; }
          &:nth-child(3) { top: 18px; }
        }

        &.is-active span {
          &:nth-child(1) {
            transform: rotate(45deg);
            top: 9px;
          }
          &:nth-child(2) {
            opacity: 0;
          }
          &:nth-child(3) {
            transform: rotate(-45deg);
            top: 9px;
          }
        }
      }
    }

    // 遮罩层
    .overlay {
      display: block;
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.5);
      z-index: 100;
      transition: opacity 0.3s ease;
    }

    // 侧滑菜单
    .mobile-menu {
      display: block;
      position: fixed;
      top: 0;
      right: -280px;
      width: 260px;
      height: 100%;
      background: #fff;
      z-index: 101;
      transition: right 0.3s ease;
      box-shadow: -2px 0 8px rgba(0, 0, 0, 0.15);
      overflow-y: auto;

      &.menu-open {
        right: 0;
      }

      .mobile-menu-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 16px 20px;
        border-bottom: 1px solid #eee;

        .menu-title {
          font-size: 16px;
          font-weight: bold;
          color: #333;
        }

        .menu-close {
          font-size: 20px;
          color: #999;
          cursor: pointer;
        }
      }

      .mobile-menu-list {
        padding: 8px 0;

        .mobile-menu-li {
          padding: 14px 20px;
          font-size: 16px;
          color: #333;
          border-bottom: 1px solid #f5f5f5;
          cursor: pointer;

          &:active {
            background: #f0f7ff;
          }
        }

        .mobile-menu-active {
          color: @primary-color;
          font-weight: bold;
          background: #f0f7ff;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/index/index.vue